import { createAsyncThunk } from '@reduxjs/toolkit'
import CategoryService from '../../../../common/category/core/service'
import { SCREEN } from '../../../../common/selectCurrencyUnit/constant'
import {
  calculateDefaultUnit,
  changeAllowSetDefaultUnit,
} from '../../../../common/selectCurrencyUnit/slice'
import { handleExport } from '../../../../helpers/export'

import FinancialStatementsService from '../core/service'
import { handleDataGetCurrency } from '../helper'

const screen = SCREEN.FINANCIAL_STATEMENT

export const financialStatementsTable = createAsyncThunk(
  'companyAnalysis/financial/financialStatements/financialStatementsTable',
  async (params, { rejectWithValue, dispatch }) => {
    const response =
      await FinancialStatementsService.getFinancialStatementsTable(params)
    if (response.success) {
      if (!response.data) {
        response.data = []
      }
      dispatch(
        calculateDefaultUnit({
          screen,
          getValues: () => handleDataGetCurrency(response.data),
        }),
      )
      dispatch(changeAllowSetDefaultUnit({ screen, value: false }))
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const financialStatementsOneYearTable = createAsyncThunk(
  'companyAnalysis/financial/financialStatements/financialStatementsOneYearTable',
  async (params, { rejectWithValue }) => {
    const response =
      await FinancialStatementsService.financialStatementsOneYearTable(params)
    if (response.success) {
      return response.data || []
    }
    return rejectWithValue(response.errors)
  },
)

export const legalRegulations = createAsyncThunk(
  'companyAnalysis/financial/financialStatements/legalRegulation',
  async (params, { rejectWithValue }) => {
    const response = await CategoryService.getLegalRegulations(params)
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const downloadFinancialData = createAsyncThunk(
  'companyAnalysis/financial/financialStatements/DOWNLOAD_FINANCIAL_DATA',
  async (data) => {
    const response = await FinancialStatementsService.downloadFinancialData(
      data,
    )
    handleExport(response.data, response.filename)
  },
)

export const getDataTransform = createAsyncThunk(
  'companyAnalysis/financial/financialStatements/getDataTransform',
  async (params, { rejectWithValue }) => {
    const response = await FinancialStatementsService.getDataTransform(params)
    if (response.success) {
      return response.data || []
    }
    return rejectWithValue(response.errors)
  },
)
